
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import UserItem from '@/components/Profile/Lists/Single/UserItem.vue'

export default defineComponent({
  name: 'FollowerUserItem',
  emits: ['removed'],
  components: {
    UserItem,
    AButton,
  },
  props: {
    subscriber: {
      type: Object,
      default: {},
    },
  },
  setup() {
    return {
      ...useRouter(),
    }
  },
})
